(function(){
  function init(section){
    if(!section||section.dataset.fuvReady==='true')return;
    section.dataset.fuvReady='true';
    var reviews=document.querySelector('.hfv-reviews');
    var description=document.querySelector('.hfv-description');
    var alreadyBeforeDescription=description&&Boolean(section.compareDocumentPosition(description)&Node.DOCUMENT_POSITION_FOLLOWING);
    if(!alreadyBeforeDescription&&reviews&&reviews.parentNode)reviews.parentNode.insertBefore(section,reviews);
    var track=section.querySelector('[data-fuv-track]');
    var cards=Array.prototype.slice.call(section.querySelectorAll('[data-fuv-card]'));
    var prev=section.querySelector('[data-fuv-prev]');
    var next=section.querySelector('[data-fuv-next]');
    var current=section.querySelector('[data-fuv-current]');
    if(!track||!cards.length)return;
    var active=0,frame=0;
    function nearest(){var left=track.scrollLeft,best=0,distance=Infinity;cards.forEach(function(card,index){var value=Math.abs(card.offsetLeft-left);if(value<distance){distance=value;best=index;}});return best;}
    function update(){active=nearest();if(current)current.textContent=String(active+1);if(prev)prev.disabled=active===0;if(next)next.disabled=active===cards.length-1;}
    function go(index){active=Math.max(0,Math.min(cards.length-1,index));cards[active].scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest',inline:'start'});window.setTimeout(update,250);}
    if(prev)prev.addEventListener('click',function(){go(active-1);});
    if(next)next.addEventListener('click',function(){go(active+1);});
    track.addEventListener('scroll',function(){cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
    cards.forEach(function(card){var video=card.querySelector('video');if(video)video.addEventListener('play',function(){cards.forEach(function(other){var otherVideo=other.querySelector('video');if(otherVideo&&otherVideo!==video)otherVideo.pause();});});});
    update();
  }
  function boot(){document.querySelectorAll('[data-fuv]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
